module.exports = {"MiniBag":{"Color":"Color","Footer":{"BagLinks":{"Bag":{"Text":"View Cart"}}}},"SearchBar":{"RecentSearches":"Recent searches"},"Icon":{"Bag":"Cart"},"CookieDisclaimer":{"link":"discover/marketing-terms-and-conditions/privacy-policy-cookies/?r=1"}}


//////////////////
// WEBPACK FOOTER
// ../i18n/en-us.json
// module id = ../i18n/en-us.json
// module chunks = client.sitechrome